import { apiClient } from './client';

export async function getPublicRegisterOptions() {
  const { data } = await apiClient.get('/api/public/register/options');
  return data.data ?? data;
}

export async function previewPublicRegisterSlug(params = {}) {
  const { data } = await apiClient.get('/api/public/register/slug-preview', { params });
  return data.data ?? data;
}

export async function previewPublicRegister(params = {}) {
  // Query strings stringify booleans as "true"/"false"; Laravel boolean rule
  // only accepts 0/1 after prepareForValidation — send 0/1 explicitly.
  const query = { ...params };
  if (Object.prototype.hasOwnProperty.call(query, 'sms_notifications_enabled')) {
    query.sms_notifications_enabled = query.sms_notifications_enabled ? 1 : 0;
  }
  const { data } = await apiClient.get('/api/public/register/preview', { params: query });
  return data.data ?? data;
}

export async function getPublicRegisterModules() {
  const { data } = await apiClient.get('/api/public/register/modules');
  return data.data ?? data;
}

export async function submitPublicTrialRegistration(payload) {
  const { data } = await apiClient.post('/api/public/register/trial', payload);
  return data.data ?? data;
}

export async function getPublicLaunchStatus(publicId) {
  const { data } = await apiClient.get(`/api/public/register/launch/${publicId}`);
  return data.data ?? data;
}

export async function retryPublicLaunch(publicId, retryCapability) {
  const { data } = await apiClient.post(`/api/public/register/launch/${publicId}/retry`, {
    retry_capability: retryCapability,
  });
  return data.data ?? data;
}

export async function getOnboardingIntents(params = {}) {
  const { data } = await apiClient.get('/api/system/onboarding-intents', { params });
  return data;
}

export async function getOnboardingIntent(id) {
  const { data } = await apiClient.get(`/api/system/onboarding-intents/${id}`);
  return data.data ?? data;
}

export async function cancelOnboardingIntent(id, payload = {}) {
  const { data } = await apiClient.post(`/api/system/onboarding-intents/${id}/cancel`, payload);
  return data.data ?? data;
}
